export const formats = {
    jpg: {
        title: 'JPG',
        mime: 'image/jpeg',
        ext: 'jpg',
    },
    png: {
        title: 'PNG',
        mime: 'image/png',
        ext: 'png',
    },
    webp: {
        title: 'WebP',
        mime: 'image/webp',
        ext: 'webp',
    },
};
